import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Login } from '../Models/login';
import { IssuerBrowseBulletinBoard } from '../Models/Issuer-Browse-Bulletin-Board';
import { environment } from '../../environments/environment';
import { IssuerArchivedDocument } from '../Models/issuer-archived-document';
import { ComplianceOverview } from '../Models/compliance-overview';
import { Browseobligor } from '../Models/browseobligor';
import { BrowseobligorService } from './browseobligor.service';

const httpPostOptions =
{
  headers:
    new HttpHeaders(
      {
        "Content-Type": "application/x-www-form-urlencoded"
      }),
  withCredentials: true,
};

const httpGetOptions =
{
  withCredentials: true,
};

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  }), withCredentials: true
};

const httpOptionsText = {
  withCredentials: true
  , responseType: 'text' as 'json'
};

function makeURLEncodedBody(_params: Object): string {

  if (!_params) return "";

  return Object.entries(_params).map(([key, value]) => encodeURIComponent(key) + "=" + encodeURIComponent(value)).join("&");
}

@Injectable({
  providedIn: 'root'
})
export class IssuerAPIService {

  APIURL = environment.apiUrl;

  private username = new BehaviorSubject("");
  _userName = this.username.asObservable();

  private lastLogin = new BehaviorSubject("");
  _lastLogin = this.lastLogin.asObservable();

  private IselectObligor = new BehaviorSubject("");
  _IselectObligor = this.IselectObligor.asObservable();

  constructor(private http: HttpClient) {

  }


  //Get Compliance Overview
  GetComplianceOverview(obligorId: string): Observable<ComplianceOverview> {
    return this.http.get<ComplianceOverview>(this.APIURL + 'IssuerCTOverview?obligorId=' + obligorId, httpOptions);
  }

  //Get Fiscal Year End
  GetFiscalYearEnd(obligorId: string): Observable<ComplianceOverview> {
    return this.http.get<ComplianceOverview>(this.APIURL + 'IssuerCTFYE?obligorId=' + obligorId, httpOptions);
  }

  //Get Incurrence Date
  GetIncurrenceDate(obligorId: string): Observable<ComplianceOverview> {
    return this.http.get<ComplianceOverview>(this.APIURL + 'IssuerCTIncurrenceDate?obligorId=' + obligorId, httpOptions);
  }

  //Get Filing Requirements
  GetFilingRequirements(obligorId: string): Observable<ComplianceOverview> {
    return this.http.get<ComplianceOverview>(this.APIURL + 'IssuerCTFilingRequirements?obligorId=' + obligorId, httpOptions);
  }

  //Get Compliance Templates
  GetComplianceTemplates(obligorId: string): Observable<ComplianceOverview> {
    return this.http.get<ComplianceOverview>(this.APIURL + 'IssuerCTTemplates?obligorId=' + obligorId, httpOptions);
  }

  //Get Compliance Templates
  GetTemplateFile(TemplateFileDocumentLink: string): Observable<ComplianceOverview> {
    return this.http.get<ComplianceOverview>(TemplateFileDocumentLink, httpGetOptions);
  }

  //Get Compliance Filing History
  GetComplianceFilingHistory(obligorId: string): Observable<ComplianceOverview> {
    return this.http.get<ComplianceOverview>(this.APIURL + 'IssuerCTFilingHistory?obligorId=' + obligorId, httpOptions);
  }

  //Get Compliance Review Findings
  GetComplianceReviewFindings(obligorId: string): Observable<ComplianceOverview> {
    return this.http.get<ComplianceOverview>(this.APIURL + 'IssuerCTFindings?obligorId=' + obligorId, httpOptions);
  }

  //Get Default Email Body
  GetDefaultEmailBody(): Observable<ComplianceOverview> {
    return this.http.get<ComplianceOverview>(this.APIURL + 'IssuerDefaultEmailBody', httpOptionsText);
  }

  // Send Issuer Email CDA Document Link
  SendIssuerEmailCDADocumentLink(obligorId: string, documentLink: string, recipientAddresses: string[], introductionText: string): Observable<ComplianceOverview> {
    debugger;
    let payload =
      { "obligorId": obligorId, "documentLink": documentLink, "recipientAddresses": recipientAddresses, "introductionText": introductionText }
    ;
    return this.http.post<ComplianceOverview>(this.APIURL + "IssuerEmailCDADocumentLink", payload, httpOptions);
  }

  //Get Issuer CT Documentation
  GetIssuerCTDocumentation(obligorId: string): Observable<ComplianceOverview> {
    return this.http.get<ComplianceOverview>(this.APIURL + 'IssuerCTDocumentation?obligorId=' + obligorId, httpOptions);
  }

  //Get Issuer CT Policies And Procedures
  GetIssuerCTPoliciesAndProcedures(obligorId: string): Observable<ComplianceOverview> {
    return this.http.get<ComplianceOverview>(this.APIURL + 'IssuerCTPoliciesAndProcedures?obligorId=' + obligorId, httpOptions);
  }

  //Get Issuer CT CUSIPs
  GetIssuerCTCUSIPs(obligorId: string): Observable<ComplianceOverview> {
    return this.http.get<ComplianceOverview>(this.APIURL + 'IssuerCTCUSIPs?obligorId=' + obligorId, httpOptions);
  }

  //Get Issuer CT Policies And Procedures CUSIPs Report
  GetIssuerCTPoliciesAndProceduresCUSIPsReport(obligorId: string): Observable<ComplianceOverview> {
    return this.http.get<ComplianceOverview>(this.APIURL + 'IssuerCTPoliciesAndProceduresCUSIPsReport?obligorId=' + obligorId, httpOptions);
  }

  //Get CT Authorizations
  GetCTAuthorizations(obligorId: string): Observable<ComplianceOverview> {
    return this.http.get<ComplianceOverview>(this.APIURL + 'CTAuthorizations?obligorId=' + obligorId, httpOptions);
  }

  // Logout Account  
  LogoutAccount(): Observable<Login> {
    debugger;
    return this.http.post<Login>(this.APIURL + 'LogoutAccount', httpPostOptions);
  }

  // Get IssuerBrowseArchivedAndCurrentDocuments
  GetIssuerBrowseArchivedAndCurrentDocuments(obligorId: string): Observable<IssuerArchivedDocument> {
    debugger;
    return this.http.get<IssuerArchivedDocument>(this.APIURL + 'IssuerBrowseArchivedAndCurrentDocuments?obligorId=' + obligorId, httpOptions);
  }
  //Get Issuer Browse Bullet-in-Board
  GetIssuerBrowseBulletinBoard(): Observable<IssuerBrowseBulletinBoard> {
    return this.http.get<IssuerBrowseBulletinBoard>(this.APIURL + 'IssuerBrowseBulletinBoard', httpOptions);
  }

  GetIssuerBrowseObligors_ReviewToolKit(IsFullAccess): Observable<Browseobligor> {
    return this.http.get<Browseobligor>(this.APIURL + 'IssuerBrowseObligors?onlyFullAccess=' + IsFullAccess, httpOptions);
  }

  //Issuer on demand webinar
  GetIssuerOnDemandWebinars(obligorId: string): Observable<any> {
    debugger;
    return this.http.get<any>(this.APIURL + 'IssuerOnDemandWebinars?obligorId=' + obligorId, httpOptions);
  }

  //Issuer upcoming webinar
  GetIssuerupcomingWebinars(obligorId: string): Observable<any> {
    debugger;
    return this.http.get<any>(this.APIURL + 'IssuerUpcomingWebinars?obligorId=' + obligorId, httpOptions);
  }

  GetUserDetails(): Observable<any> {
    debugger;

    return this.http.get<any>(this.APIURL + 'UserDetails', httpOptions);
  }

  GetUserDataFromLocalStorage(): void {
    if (localStorage.getItem("User_Name")) {
      this.username.next(localStorage.getItem("User_Name"));
      this.lastLogin.next(localStorage.getItem("Last_Login"));
      this.IselectObligor.next(localStorage.getItem("IsSelect_Obligor"));
    }
  }

  // Send ResetPasword link
  SendForgotPassword_UserNameEmail(email: string, username: string): Observable<any> {
    debugger;
    let user_email = makeURLEncodedBody({ "email": email, "username": username });
    return this.http.post<any>(this.APIURL + "ForgotPassword", user_email, httpPostOptions);
  }

  // password change rules api
  GetPasswordRules(): Observable<any>{
    return this.http.get<any>(this.APIURL + 'QueryPasswordRules', httpOptions);

  }


  // Password Reset API
  ResetPassword_Eng(password: string, confirmPassword: string, code: string): Observable<any> {
    debugger;
    let reset_password = makeURLEncodedBody(
      { "password1": password, "password2": confirmPassword, "p": code }
    );
    return this.http.post<any>(this.APIURL + "ResetPassword", reset_password, httpPostOptions);
  }
}
